module.exports = __webpack_public_path__ + "r-v3/img/sticker_7.4645d5bc.svg";